import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-chip',
  templateUrl: './st-chip.component.html',
  styleUrls: ['./st-chip.component.scss'],
  standalone: false
})
export class StChipComponent {

  @Input()
  idVal: string = 'chipId';

  @Input()
  primary = false;

  @Input()
  displayValue = 'chip';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000'

  @Output()
  onClick = new EventEmitter<Event>();
}
